module.exports = __webpack_public_path__ + "static/media/builtinv2-tv.2de93358.png";